<template>
  <v-app>
    <v-container fluid>
       <v-row>
         <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Promotion Report Search
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <!-- Filters Row 1 -->
                <v-row class="py-1 px-2 " style="margin-bottom: -22px;">
                  <v-col md="3" cols="12">
                    <v-select
                      v-model="filters.department_id"
                      :items="departments"
                      item-title="name"
                      item-value="id"
                      label="Department"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      prepend-inner-icon="mdi-office-building"
                    
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-select
                      v-model="filters.designation_id"
                      :items="designations"
                      item-title="name"
                      item-value="id"
                      label="Designation"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      prepend-inner-icon="mdi-badge-account"
                    
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-select
                      v-model="filters.employee_type_id"
                      :items="employeeTypes"
                      item-title="name"
                      item-value="id"
                      label="Employee Type"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      prepend-inner-icon="mdi-account-tie"
                    
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
                  </v-col>
                  <v-col md="3" cols="12">
                    <!-- Empty space for alignment -->
                  </v-col>
                </v-row>

                <!-- Date Range Filters and Search Button Row 2 -->
                <v-row class="py-0 px-2" style="margin-top: -8px;">
                  <v-col md="3" cols="12">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="filters.from_date"
                      label="From Date"
                      density="compact"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-start"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      autocomplete="off"
                      clearable
                    ></v-date-input>
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="filters.to_date"
                      label="To Date"
                      density="compact"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-end"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      autocomplete="off"
                      clearable
                    ></v-date-input>
                  </v-col>
                  <v-col md="3" cols="12">
                    <div class="d-flex justify-start align-center" style="gap: 12px;">
                      <v-btn 
                        class="bg-brand w-15" 
                        type="submit" 
                        ref="searchButton"
                        @click="loadReport"
                      >
                        Search
                      </v-btn>
                      <v-btn
                        class="bg-warning w-15"
                        type="button"
                        prepend-icon="mdi-refresh"
                        @click="clearFilters"
                        title="Reset all filters and search"
                      >
                        Reset
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col md="3" cols="12">
                    <!-- Empty space for alignment -->
                  </v-col>
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- Promotion Report List -->
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Promotion Report List
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="3" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          :disabled="!filteredEmployees.length"
                        >CSV</v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          :disabled="!filteredEmployees.length"
                        >EXCEL</v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          :disabled="!filteredEmployees.length"
                        >PDF</v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <!-- Empty space for alignment -->
                  </v-col>
                </v-row>

                <v-card class="overflow-x-auto">
                  <v-data-table
                    :headers="headers"
                    :items="filteredEmployees"
                    :loading="loading"
                    v-model:items-per-page="itemsPerPage"
                    :search="search"
                    :hover="true"
                    density="compact"
                    class="min-width-1200"
                  >
                    <template v-slot:item.index="{ index }">
                      {{ ++index }}
                    </template>

                    <template v-slot:item.employee_name="{ item }">
                      <span class="font-weight-medium">{{ item.employee_name }}</span>
                    </template>

                    <template v-slot:item.employee_code="{ item }">
                      <span class="text-caption">{{ item.employee_code }}</span>
                    </template>

                    <template v-slot:item.increment_date="{ item }">
                      <span class="text-caption">{{ formattedDate(item.increment_date) }}</span>
                    </template>

                    <template v-slot:item.current_designation="{ item }">
                      <span class="text-caption">{{ item.current_designation || '-' }}</span>
                    </template>

                    <template v-slot:item.designation="{ item }">
                      <span class="text-caption">{{ item.new_designation || '-' }}</span>
                    </template>

                    <template v-slot:item.before_gross_salary="{ item }">
                      <v-chip size="small" variant="tonal">
                        ৳{{ formatNumber(item.before_gross_salary) }}
                      </v-chip>
                    </template>

                    <template v-slot:item.after_gross_salary="{ item }">
                      <v-chip size="small" variant="tonal">
                        ৳{{ formatNumber(item.after_gross_salary) }}
                      </v-chip>
                    </template>

                    <template v-slot:item.salary_effect_date="{ item }">
                      <span class="text-caption">{{ formattedDate(item.salary_effect_date) }}</span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- No Data Message -->
      <v-card v-if="!loading && (!reportData.promotion_months || reportData.promotion_months.length === 0)" class="mt-4">
        <v-card-text class="text-center py-8">
          <v-icon size="64" color="grey-lighten-1">mdi-chart-line-variant</v-icon>
          <div class="text-h6 text-grey mt-4">No Promotion Data Found</div>
          <div class="text-body-2 text-grey">Try adjusting your search criteria</div>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { toast } from 'vue3-toastify'
import formattedDate from '@/plugins/dateFormatter'

// Router and Store
const router = useRouter()
const store = useStore()

// Get Vue instance for export functions
const instance = getCurrentInstance()

// Reactive data
const panel = ref([0])
const search = ref('')
const loading = ref(false)
const itemsPerPage = ref(10)
const reportData = ref({})
const departments = ref([])
const designations = ref([])
const employeeTypes = ref([])
const branches = ref([])

// Filters
const filters = reactive({
  department_id: null,
  designation_id: null,
  employee_type_id: null,
  from_date: null,
  to_date: null
})

// Table headers - matching increment report structure
const headers = ref([
  { title: '#SL', key: 'index', sortable: false, align: 'center' },
  { title: 'Employee Name', key: 'employee_name', sortable: true, align: 'center' },
  { title: 'Code', key: 'employee_code', sortable: true, align: 'center' },
  { title: 'Promotion Date', key: 'increment_date', sortable: true, align: 'center' },
  { title: 'Ref No', key: 'promotion_ref_no', sortable: true, align: 'center' },
  { title: 'Old Designation', key: 'current_designation', sortable: true, align: 'center' },
  { title: 'New Designation', key: 'designation', sortable: true, align: 'center' },
  { title: 'Salary Before Promotion', key: 'before_gross_salary', sortable: true, align: 'center' },
  { title: 'Salary After Promotion', key: 'after_gross_salary', sortable: true, align: 'center' },
  { title: 'Salary Effect Date', key: 'salary_effect_date', sortable: true, align: 'center' },
])

// Computed properties
const flattenedEmployees = computed(() => {

  const employees = []
  reportData.value?.promotion_months?.forEach((month, monthIndex) => {
    
    // Handle both arrays and Laravel Collections
    let employeeList = month.employees
    if (month.employees && typeof month.employees === 'object' && month.employees.items) {
      // It's a Laravel Collection, extract the items
      employeeList = month.employees.items || Object.values(month.employees)
    }
    
    
    if (employeeList && Array.isArray(employeeList)) {
      employeeList.forEach((employee, empIndex) => {

        employees.push({
          ...employee,
          employee_name: employee.name,
          employee_code: employee.code,
          promotion_date: employee.promotion_date,
          current_designation: employee.current_designation || employee.current_designation_name || employee.designation?.name,
          current_basic_salary: employee.current_basic_salary,
          new_basic_salary: employee.new_basic_salary,
          salary_effect_date: employee.salary_effect_date,
          designation: employee.designation,
          promotion_ref_no: employee.promotion_ref_no
        })
      })
    }
  })
  
  return employees
})

const filteredEmployees = computed(() => {
  if (!search.value) return flattenedEmployees.value
  
  const searchQuery = search.value.toLowerCase().trim()
  if (!searchQuery) return flattenedEmployees.value
  
  const filtered = flattenedEmployees.value.filter(employee => {
    if (employee.name && employee.name.toLowerCase().includes(searchQuery)) return true
    if (employee.code && employee.code.toLowerCase().includes(searchQuery)) return true
    if (employee.designation?.name && employee.designation.name.toLowerCase().includes(searchQuery)) return true
    if (employee.department?.name && employee.department.name.toLowerCase().includes(searchQuery)) return true
    if (employee.promotion_date && employee.promotion_date.toLowerCase().includes(searchQuery)) return true
    if (employee.promotion_ref_no && employee.promotion_ref_no.toLowerCase().includes(searchQuery)) return true
    return false
  })
  
  return filtered
})

// Methods
const loadReport = async () => {
  loading.value = true
  try {
    const params = {
      department_id: filters.department_id,
      designation_id: filters.designation_id,
      employee_type_id: filters.employee_type_id,
      from_date: formattedDate(filters.from_date),
      to_date: formattedDate(filters.to_date),
    }
    
    const response = await store.dispatch('getPromotionReport', params)
    
    if (response.data.success) {
      reportData.value = response.data.data
    } else {
      console.error('API returned error:', response.message)
      toast.error(response.message || 'Failed to load promotion report')
    }
  } catch (error) {
    console.error('Error loading promotion report:', error)
    toast.error('Error loading promotion report: ' + error.message)
  } finally {
    loading.value = false
  }
}

const clearFilters = () => {
  filters.department_id = null
  filters.designation_id = null
  filters.employee_type_id = null
  filters.from_date = null
  filters.to_date = null
  search.value = ''
  loadReport()
}

const loadDropdowns = async () => {
  try {
    const [deptResponse, desigResponse, empTypeResponse] = await Promise.all([
      store.dispatch('getDepartments'),
      store.dispatch('getDesignations'),
      store.dispatch('getEmployeeTypes')
    ])
    
    departments.value = deptResponse.data.data || []
    designations.value = desigResponse.data.data || []
    employeeTypes.value = empTypeResponse.data.data || []
    branches.value = [] // Branch filter removed for simplicity
  } catch (error) {
    console.error('Error loading dropdowns:', error)
  }
}

const formatNumber = (number) => {
  if (!number || number === 0) return '0.00'
  try {
    return parseFloat(number).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  } catch (error) {
    return '0.00'
  }
}

const viewEmployee = (employeeId) => {
  router.push(`/hrm/employee-details/${employeeId}`)
}

// Export functions
const exportToCSV = () => {
  const data = [['#', 'Employee Name', 'Code', 'Promotion Date', 'Before Designation', 'Before Promotion', 'Current Basic Salary', 'Salary Effect Date', 'Designation']]
  
  filteredEmployees.value.forEach((item, index) => {
    data.push([
      index + 1,
      item.employee_name || '-',
      item.employee_code || '-',
      formattedDate(item.promotion_date),
      item.current_designation || '-',
      formatNumber(item.current_basic_salary),
      formatNumber(item.new_basic_salary),
      formattedDate(item.salary_effect_date),
      item.designation?.name || '-'
    ])
  })
  
  instance.proxy.$exportTableToCSV(data, "promotion_report_" + instance.proxy.$fileDate())
}

const exportToExcel = () => {
  const data = [['#', 'Employee Name', 'Code', 'Promotion Date', 'Before Designation', 'Before Promotion', 'Current Basic Salary', 'Salary Effect Date', 'Designation']]
  
  filteredEmployees.value.forEach((item, index) => {
    data.push([
      index + 1,
      item.employee_name || '-',
      item.employee_code || '-',
      formattedDate(item.promotion_date),
      item.current_designation || '-',
      formatNumber(item.current_basic_salary),
      formatNumber(item.new_basic_salary),
      formattedDate(item.salary_effect_date),
      item.designation?.name || '-'
    ])
  })
  
  instance.proxy.$exportTableToExcel(data, "promotion_report_" + instance.proxy.$fileDate())
}

const exportToPDF = () => {
  let serialNumber = 1
  const columns = [
    "#", 
    "Employee Name", 
    "Code", 
    "Promotion Date",
    "Before Designation",
    "Before Promotion",
    "Current Basic Salary",
    "Salary Effect Date",
    "Designation"
  ]
  const rows = filteredEmployees.value.map((item) => [
    serialNumber++,
    item.employee_name || '-',
    item.employee_code || '-',
    formattedDate(item.promotion_date),
    item.current_designation || '-',
    formatNumber(item.current_basic_salary),
    formatNumber(item.new_basic_salary),
    formattedDate(item.salary_effect_date),
    item.designation?.name || '-'
  ])
  
  instance.proxy.$exportTableToPDF(columns, rows, "Promotion Report", "promotion_report_" + instance.proxy.$fileDate())
}

// Lifecycle
onMounted(() => {
  loadDropdowns()
  loadReport()
})
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}

.min-width-1200 {
  min-width: 1200px;
}
</style>